module.exports = __webpack_public_path__ + "img/full6-min.7f667c4c.png";